import React from 'react'

const PlayIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <g clipPath='url(#clip0_8765_57572)'>
        <path
          d='M15 7.99958C15.0004 8.16935 14.9569 8.33633 14.8736 8.48429C14.7904 8.63226 14.6703 8.75616 14.525 8.84395L5.52 14.3527C5.36818 14.4457 5.19429 14.4964 5.0163 14.4997C4.83831 14.503 4.66266 14.4587 4.5075 14.3715C4.35382 14.2855 4.2258 14.1602 4.1366 14.0084C4.04741 13.8566 4.00026 13.6838 4 13.5077V2.49145C4.00026 2.31538 4.04741 2.14256 4.1366 1.99075C4.2258 1.83894 4.35382 1.71363 4.5075 1.6277C4.66266 1.54042 4.83831 1.49614 5.0163 1.49944C5.19429 1.50274 5.36818 1.55349 5.52 1.64645L14.525 7.1552C14.6703 7.243 14.7904 7.3669 14.8736 7.51487C14.9569 7.66283 15.0004 7.82981 15 7.99958Z'
          fill='#0095FF'
        />
      </g>
      <defs>
        <clipPath id='clip0_8765_57572'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PlayIcon
